import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { css } from 'aphrodite/no-important';
import styles from './NoSitesFound.styles';
import Button from '../../components/inputs/button/Button';

export class NoSitesFound extends Component {
  goToAdmin = () => {
    this.props.history.push('/admin');
  };

  isAdmin = () => {
    return ['superadmin','admin'].indexOf(this.props.orgUserRole) > -1
  };

  renderAdminView = () => {
    return (
      <Fragment>
        <div className={css(styles.item)}>
        There are no sites found, please create one.
        </div>
        <div className={css(styles.item)}>
          <Button onClick={this.goToAdmin}>Create Site</Button>
        </div>
      </Fragment>
    );
  };

  renderNonAdminView = () => {
    return (
      <Fragment>
        <div className={css(styles.item)}>
          There are no sites found, please ask the Organization Admin to create one.
        </div>
        {
          this.props.orgCount > 1 ?
            <div className={css(styles.item)}>
              <a className={css(styles.link)} href="/v/index.html#/selectorgs">Select a Different Organization</a>
            </div>
            : null
        }
      </Fragment>
    );
  };

  render() {
    if (this.props.sitesLoading || this.props.sitesList.length) {
      return <Redirect to='/' />;
    }
    return (
      <div className={css(styles.base)}>
        {
          this.isAdmin() ?
          this.renderAdminView() :
          this.renderNonAdminView()
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    sites: { 
      list: sitesList,
      loading: sitesLoading
    },
    organizations: {
      orgCount,
      orgUserRole
    }
  } = state;
  return {
    sitesList,
    sitesLoading,
    orgCount,
    orgUserRole
  };
};

export default connect(mapStateToProps)(NoSitesFound);



// WEBPACK FOOTER //
// ./src/containers/nositesfound/NoSitesFound.js